import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

function MyPredictions() {
  const [predictions, setPredictions] = useState([]);
  const [campeonatos, setCampeonatos] = useState([]);
  const [selectedCampeonato, setSelectedCampeonato] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampeonatos = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/campeonatos`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setCampeonatos(response.data);
      } catch (error) {
        setError('Erro ao carregar campeonatos.');
      }
    };
    fetchCampeonatos();
  }, []);

  useEffect(() => {
    const fetchPredictions = async () => {
      try {
        setLoading(true);
        const params = selectedCampeonato ? { campeonato_id: selectedCampeonato } : {};
        const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/predictions`, {
          params,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setPredictions(response.data);
        setError(null);
      } catch (error) {
        setError(error.response?.data?.message || 'Não foi possível carregar seus palpites.');
      } finally {
        setLoading(false);
      }
    };
    fetchPredictions();
  }, [selectedCampeonato]);

  // Função para obter a URL da miniatura 150x150px
  const getThumbnailUrl = (url) => {
    if (!url) return ''; // Retorna vazio se a URL não existir
    const extensionIndex = url.lastIndexOf('.');
    const baseUrl = url.substring(0, extensionIndex);
    const extension = url.substring(extensionIndex);
    return `${baseUrl}-150x150${extension}`;
  };

  return (
    <div className="predictions-container">
      <h2>Meus Palpites</h2>
      <div className="filter-container">
        <label>Filtrar por campeonato:</label>
        <select
          value={selectedCampeonato}
          onChange={(e) => setSelectedCampeonato(e.target.value)}
        >
          <option value="">Todos os campeonatos</option>
          {campeonatos.map((campeonato) => (
            <option key={campeonato.id} value={campeonato.id}>
              {campeonato.nome} {campeonato.ano}
            </option>
          ))}
        </select>
      </div>
      {loading && <p>Carregando palpites...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && predictions.length === 0 && <p>Você ainda não fez nenhum palpite.</p>}
      {!loading &&
        !error &&
        predictions.length > 0 && (
          <div className="predictions-list">
            {predictions.map((prediction, index) => (
              <div key={prediction.id} className="prediction-item">
                <div className="match-teams">
                  <div className="team team-left">
                    <img
                      src={getThumbnailUrl(prediction.escudo_time1)}
                      alt={prediction.team1}
                      className="team-logo instagram"
                    />
                    <span>{prediction.team1}</span>
                  </div>
                  <div className="score">
                    <span>{prediction.score1}</span>
                    <span className="vs">X</span>
                    <span>{prediction.score2}</span>
                  </div>
                  <div className="team team-right">
                    <span>{prediction.team2}</span>
                    <img
                      src={getThumbnailUrl(prediction.escudo_time2)}
                      alt={prediction.team2}
                      className="team-logo arg-digital"
                    />
                  </div>
                </div>
                {index < predictions.length - 1 && <hr className="separator" />}
              </div>
            ))}
          </div>
        )}
    </div>
  );
}

export default MyPredictions;